// extracted by mini-css-extract-plugin
export var bgimageContainer = "basicPage-module--bgimageContainer--0uVzv";
export var header = "basicPage-module--header--1vFGn";
export var mainImageContainer = "basicPage-module--mainImageContainer--lenRz";
export var titleContainer = "basicPage-module--titleContainer--6azVY";